import {IssueReportingChatMessage} from "../api/issueReporting.ts";
import {css} from "@pandacss/css";
import {FC, useEffect, useMemo} from "react";
import {
    AssistantIssueCreatedMessageDisplay,
    AssistantMessageDisplay,
    AssistantYesNoQuestionDisplay,
    UserMessageDisplay, UserPhotoMessageDisplay, WaitingForResponseMessageDisplay
} from "../molecules/ChatMessage.tsx";

interface Props {
    messages: IssueReportingChatMessage[],
    waitingForResponse: boolean,
    onStartNewChat: () => void,
    onYesNoResponse: (response: 'yes' | 'no') => void,
    disableInput: boolean,
    siteId: string,
}

const chatMessageColumnClass = css({
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    flex: 1,
    overflowY: "auto"
})

const scrollToBottomOfPage = () => {
    window.scrollTo({
        top: document.body.scrollHeight
    });
}

const ChatMessages: FC<Props> = ({ messages, waitingForResponse, onStartNewChat, onYesNoResponse, disableInput, siteId }) => {
    const photoFileKeys = useMemo<Record<string, string>>(() => {
        const results: Record<string, string> = {}
        messages.forEach(m => {
            if (m.type === 'userPhoto') {
                results[m.photoId] = m.fileKey
            }
        })
        return results
    }, [messages])

    useEffect(scrollToBottomOfPage, [messages]);

    return <div className={chatMessageColumnClass}>
        {messages.map((message) => {
            console.log('[FRONTEND ChatMessages] Rendering message:', message.type, message);
            if (message.type === 'userMessage') return <UserMessageDisplay key={message.id} message={message} />
            if (message.type === 'assistantMessage') return <AssistantMessageDisplay key={message.id} message={message} />
            if (message.type === 'assistantYesNoQuestion') return <AssistantYesNoQuestionDisplay key={message.id} message={message} onYesNoResponse={onYesNoResponse} disabled={disableInput} />
            if (message.type === 'assistantIssueCreated') return <AssistantIssueCreatedMessageDisplay key={message.id} message={message} onStartNewChat={onStartNewChat} photoFileKeys={photoFileKeys} siteId={siteId}/>
            if (message.type === 'userPhoto') return <UserPhotoMessageDisplay key={message.id} message={message} />
            if (message.type === 'userYesNoResponse') return <UserMessageDisplay key={message.id} message={{id: message.id, type: 'userMessage', content: message.response === 'yes' ? 'Yes' : 'No'}} />
            return null
        })}
        {waitingForResponse && <WaitingForResponseMessageDisplay />}
    </div>
}

export default ChatMessages